
import { AddressCard } from "@/components/shared/AddressCard";
import { consultorios } from "@/data/consultorios";

export function OfficeLocations() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto mobile-container">
        <h2 className="text-2xl sm:text-3xl font-bold font-primary text-gray-800 mb-8 text-center">
          Nossos Consultórios
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {consultorios.map((consultorio) => (
            <AddressCard
              key={consultorio.id}
              name={consultorio.name}
              address={consultorio.address}
              city={consultorio.city}
              cep={consultorio.cep}
              complement={consultorio.complement}
              phone={consultorio.phone}
              horarios={consultorio.horarios}
              showHours={true}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
